import axios from 'axios';
// import store from '../store/index'
import { message } from 'ant-design-vue';


const ajax = axios.create({
  // baseURL: process.env.VUE_APP_URL,
  baseURL: process.env.VUE_APP_URL,
  // baseURL: 'http://yapi.tianxiapiao.cn/mock/11/',
  timeout: 16000,
});
//
ajax.interceptors.request.use(config => {
  //请求前
  let token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config
}, error => {

  Promise.reject(error);
});

let temp = ajax.interceptors.response.use(

  response => {
    const res = response.data
    //请求后
    if (res.code === 200) {
      return res.data
    } else {
      message.error({
        content: res.message
      })

      if (res.code == 417) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = window.location.origin + '/train-admin/login'
        return;
      }

      return Promise.reject(res)
    }
  },
  error => {
    message.error(error.message)
    const errorResponse = error.response;

    return Promise.reject(errorResponse)
  });
export default ajax
